module.exports = __webpack_public_path__ + "static/media/logo-prepi.964607a7.png";